import { HttpRequest } from '@angular/common/http';
import { Injectable, Injector, inject } from '@angular/core';
import { Observable, catchError, first, map, of, timeout } from 'rxjs';

import { ConfigurationService } from '../configuration';
import { AUTHORITIES_URLS, BPS_EINSTELLUNGEN_ENDPOINT, SKIP_JAP_HEADER_REQUEST } from '../endpoint.consts';
import { RwcInterceptor } from '../http/rwc-interceptor';
import { setHeader } from '../http/set-header';
import { HTTP_HEADER_W3C_BAGGAGE, W3cBaggage } from '../http/w3cBaggage';

import { LanguageService } from './language.service';
import { Language } from './language.types';

const IGNORED_URLS = [...AUTHORITIES_URLS, BPS_EINSTELLUNGEN_ENDPOINT];

@Injectable({ providedIn: 'root' })
export class LanguageInterceptor implements RwcInterceptor {
    #injector = inject(Injector);
    #configurationService = inject(ConfigurationService);

    // The request to Einstellungen endpoint must be ignored because the B2eLanguageProvider
    // get the language from it.
    private LANGUAGE_RESPONSE_TIMEOUT_MS = 500;
    private language$?: Observable<Language>;

    appliesToRequest(req: HttpRequest<unknown>): boolean {
        return (
            !req.context.get(SKIP_JAP_HEADER_REQUEST) && !IGNORED_URLS.some(ignoredUrl => req.url.includes(ignoredUrl))
        );
    }

    interceptRequest(req: HttpRequest<unknown>): Observable<HttpRequest<unknown>> {
        if (!this.language$) {
            this.language$ = this.#injector.get(LanguageService).language$;
        }
        return this.language$.pipe(
            map(lang => this.setLanguageHeader(req, lang)),
            first(),
            timeout(this.LANGUAGE_RESPONSE_TIMEOUT_MS),
            catchError(err => {
                console.error(err);
                return of(req);
            })
        );
    }

    private setLanguageHeader(request: HttpRequest<unknown>, lang: Language): HttpRequest<unknown> {
        if (this.#configurationService.getSync('isCloudApp')) {
            const baggage = new W3cBaggage(request).add('language', lang);
            return setHeader(request, HTTP_HEADER_W3C_BAGGAGE, baggage.toString());
        } else {
            return setHeader(request, 'x-language', lang);
        }
    }
}
